import type { ProfileOrgResponse } from '@on3/api';
import { On3Avatar } from 'components/Image/On3Avatar';
import { StarRating } from 'components/UI/StarRating/StarRating';
import { createTitle } from 'utils/meta';

import styles from './CollegeRanking.module.scss';

export const CollegeRanking = ({
  organization,
  expMin,
  expMax,
  year,
  age,
  rating,
  positionAbbr,
}: ProfileOrgResponse) => {
  const { name, asset, mascot } = organization || {};

  return (
    <section className={styles.block}>
      <h2>{createTitle(name, mascot)}</h2>
      <div>
        {!!rating?.rating && rating?.rating > 50 && (
          <>
            <div className={styles.row}>
              <span className={styles.label}>On3 College Rating</span>
              <div className={styles.ratings}>
                <StarRating large stars={rating?.stars || 0} />
                <span>{rating?.rating?.toFixed(2) || '-'}</span>
                {asset && (
                  <On3Avatar
                    domain={asset.domain}
                    height={25}
                    source={asset.source}
                    teamAvatar
                    type={asset?.type}
                    width={25}
                  />
                )}
              </div>
            </div>
            <div className={styles.row}>
              <span className={styles.label}>College Rankings</span>
              <div className={styles.rankings}>
                <div className={styles.ranking}>
                  <span>Natl</span>
                  <span>{rating?.nationalRank || '-'}</span>
                </div>
                <div className={styles.ranking}>
                  <span>{positionAbbr || '-'}</span>
                  <span>{rating?.positionRank || '-'}</span>
                </div>
              </div>
            </div>
          </>
        )}
        <div className={styles.row}>
          <span className={styles.label}>Experience</span>
          <div>
            <span>
              {expMin} -{' '}
              {expMax && expMax >= new Date().getFullYear()
                ? 'present'
                : expMax}
            </span>
          </div>
        </div>
        {expMax && expMax >= new Date().getFullYear() && (
          <div className={styles.row}>
            <span className={styles.label}>Year</span>
            <div>
              <span>{year}</span>
            </div>
          </div>
        )}
        <div className={styles.row}>
          <span className={styles.label}>Age</span>
          <div>
            <span>{age || '-'}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
